<template>
    <div @click="toggleChatWindowStatus(type)" class="typeChat">
        <div v-html="type.text" class="type-wrapper"></div>
    </div>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import store from "@/store";

export default {
    name: 'TypeChat',
    props: ['type', "llave"],
    methods: {
        ...mapMutations(['changeChatWindowStatus', 'emptyChatWindow']),
        toggleChatWindowStatus(value) {
            this.$store.http.createThread(value.id);

            /*
              if(this.waitingList == 0){
                  this.emptyChatWindow();
                  this.changeChatWindowStatus(3);
              }else{
                  this.changeChatWindowStatus(2);
              }
            */

        },
    },
    computed: {
        ...mapState(['chatType', 'chatWindowStatus', 'waitingList']),
    }
}
</script>